module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/SOCIOLOGY-aea17e6a00e289e2317cd48b4a7a9c76.png";